import React, {useState, useEffect} from 'react';
import Button from "@material-ui/core/Button";
import {Dialog, IconButton} from "@material-ui/core";
import NewCreateOrder from "../../pages/createOrder/newCreateOrder";
import Grid from "@material-ui/core/Grid";
import RequestPickup from "../../pages/requestPickup/requestPickup";
import CheckInventory from "../checkInventory/checkInventory";
import RequestExchange from "../../pages/requestExchange/requestExchange";
import ToolIcon from "../../assets/tool.svg";
import {Person, PlusOne} from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import {useHistory} from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import {TextField} from "@material-ui/core";
import {labels} from "../../constants/inputs/labels";
import {makeStyles} from '@material-ui/core/styles';

const useStyles2 = makeStyles({
    table: {
        minWidth: 500,
    },
    searchHeaderTextField: {
        background: "white"
    },
    deliveryButton: {
        color: '#FFFFFF',
        backgroundColor: '#315464',
        fontSize: 12,
        fontWeight: 'bold',
        border: 'none',
        width: '350px',
        height: '40px',
        "&:hover": {
            backgroundColor: '#416e82'
        }
    },
    exchangeButton: {
        color: '#FFFFFF',
        backgroundColor: '#84B4C2',
        fontSize: 12,
        width: '350px',
        height: '40px',
        "&:hover": {
            backgroundColor: '#BBD3DE'
        },
        border: 'none',
    },
    pickupButton: {
        color: '#FFFFFF',
        backgroundColor: '#4F86A0',
        border: 'none',
        fontSize: 12,
        fontWeight: 'bold',
        width: '350px',
        height: '40px',
        paddingTop: 8,
        paddingBottom: 8,
        "&:hover": {
            backgroundColor: '#77A6BC'
        }
    },
    disabledDeliveryButton: {
        fontSize: 12,
        fontWeight: 'bold',
        width: '350px',
        height: '40px'
    },
    disabledPickupButton: {
        fontSize: 12,
        fontWeight: 'bold',
        width: '350px',
        height: '40px'
    },
    disabledExchangeButton: {
        fontSize: 12,
        fontWeight: 'bold',
        width: '350px',
        height: '40px'
    },
    paddingTop8: {
        "&.MuiGrid-item": {
            paddingTop: 8
        }
    },
    paddingBottom8: {
        "&.MuiGrid-item": {
            paddingBottom: 8
        }
    },
    padding0: {
        "&.MuiGrid-item": {
            padding: 0
        }
    },
    standardButton: {
        fontSize: 12,
        fontWeight: 'bold',
        height: '40px',
        width: '350px',
    },
    ActionsDialogTitle: {
        "&.MuiTypography-h6": {
            fontWeight: 700
        }
    },
    fontSize14: {
        "&.MuiGrid-item": {
            fontSize: 14
        },
        "&.MuiTypography-overline": {
            fontSize: 14
        }
    },
    patientActionSectionHeader: {color: 'grey'},
    fontWeight700: {
        "&.MuiTypography-body1": {fontWeight: 600}
    },
});

export function NewRequest({user, getPatientOrders, isPace, address, name,autoPickupTrigger,autoPickupReason, fullWidth, hasItems}){
    const [open, setOpen] = useState(false);
    const history = useHistory();
    function closeMobileModal(){
        setOpen(false);
    }
   const [openActions, setOpenActions] = useState(false);
   const [showClose, setShowClose] = useState(false);
   const classes = useStyles2();
   const [orderAddress, setOrderAddress] = useState({
     address1: '',
     address2: '',
     city: '',
     state: '',
     zip: ''
   });

useEffect(() => {
  if (user && Object.keys(user).length > 0) {
    setOrderAddress({
      address1: user.address1 || '',
      address2: user.address2 || '',
      city: user.city || '',
      state: user.state || '',
      zip: user.zip || ''
    });
  }
}, [user]);

    const handleInput = (e) => {
         const { name, value } = e.target;
         setOrderAddress((prev) => ({
           ...prev,
           [name]: value
         }));
       };
     const handleConfirmButton = (e) => {
               setShowClose(true);
               handleSaveAddress();
           }

     const handleSaveAddress = () => {
         console.log("Address saved: ", orderAddress);
       }
    return (
        <React.Fragment>
            <Button onClick={()=> setOpen(true)} variant={'contained'}
                    fullWidth={fullWidth}
                    style={{
                        backgroundColor: fullWidth ? '#00223D' :'#4F879F',
                        color:'white',
                        textTransform:'uppercase',
                        fontWeight:'bold',
                        maxWidth:420
                    }}
            ><AddIcon style={{marginRight:4}}/> New Request</Button>
            <Dialog open={open} onClose={()=>setOpen(false)}>
                <Grid container direction={'column'} alignItems={'center'} style={{padding:16}}>
                    <Grid container justify={'space-between'} alignContent={'center'} alignItems={'center'} style={{fontSize:16, fontWeight:'bold', paddingBottom:8, textAlign:'center'}}>
                        <span style={{paddingLeft:16}}>Select Order Type</span>
                        <IconButton onClick={()=> closeMobileModal()}>
                            <CloseIcon/>
                        </IconButton>
                    </Grid>
                    {hasItems && user.status !== 'Active' ? (
                        <RequestPickup
                            openOrder={false}
                            showPickup={true}
                            name={name}
                            address={address}
                            patient_id={user.patient_id}
                            getPatientOrders={getPatientOrders}
                            closeMobileModal={closeMobileModal}
                            mobileButton={true}
                        />
                    ) : (
                        <React.Fragment>
                            <Grid item style={{padding:16}}>
                                { ([11].includes(Number(user.hospice_organization_id))) ?
                                                         <Grid item xs={12} alignContent={'flex-start'} alignItems={'flex-start'}>
                                                             <Typography className={classes.fontSize14}><span
                                                                style={{color: 'gray'}}>Delivery/Pickup Address: </span>
                                                             </Typography>
                                                         </Grid>
                                                         : "" }
                                { ([11].includes(Number(user.hospice_organization_id))) ?
                                                        <Grid item xs={12} alignContent={'flex-start'} alignItems={'flex-start'}>
                                                        <TextField
                                                                                    id="address1"
                                                                                    name="address1"
                                                                                    label={labels.address1}
                                                                                    placeholder="Update address1"
                                                                                    value={orderAddress.address1}
                                                                                    fullWidth
                                                                                    variant={"outlined"}
                                                                                    size={"small"}
                                                                                    style={{marginBottom: "10px"}}
                                                                                    onChange={handleInput}
                                                                                />
                                                        <TextField
                                                            id="address2"
                                                            name="address2"
                                                            label={labels.address2}
                                                            placeholder="Update address2"
                                                            value={orderAddress.address2}
                                                            fullWidth
                                                            variant={"outlined"}
                                                            size={"small"}
                                                            style={{marginBottom: "10px"}}
                                                            onChange={handleInput}
                                                        />
                                                        <TextField
                                                            id="city"
                                                            name="city"
                                                            label={labels.city}
                                                            placeholder="Update city"
                                                            value={orderAddress.city}
                                                            fullWidth
                                                                                    variant={"outlined"}
                                                                                    size={"small"}
                                                                                    style={{marginBottom: "10px"}}
                                                                                    onChange={handleInput}
                                                                                />
                                                                                <TextField
                                                                                                            id="state"
                                                                                                            name="state"
                                                                                                            label={labels.state}
                                                                                                            placeholder="Update state"
                                                                                                            value={orderAddress.state}
                                                                                                            fullWidth
                                                                                                            variant={"outlined"}
                                                                                                            size={"small"}
                                                                                                            style={{marginBottom: "10px"}}
                                                                                                            onChange={handleInput}
                                                                                                        />
                                                                                                        <TextField
                                                                                                                                    id="zip"
                                                                                                                                    name="zip"
                                                                                                                                    label={labels.zip}
                                                                                                                                    placeholder="Update zip"
                                                                                                                                    value={orderAddress.zip}
                                                                                                                                    fullWidth
                                                                                                                                    variant={"outlined"}
                                                                                                                                    size={"small"}
                                                                                                                                    onChange={handleInput}
                                                                                                                                />
                                                        </Grid>
                                                        : "" }
                                { ([11].includes(Number(user.hospice_organization_id))) ?
                                                        <Grid item xs={12} classes={{root: classes.paddingBottom8}}>
                                                            <Button
                                                              variant="contained"
                                                              size="small"
                                                              color="primary"
                                                              onClick={() => handleConfirmButton()}
                                                              className={classes.standardButton}
                                                            >
                                                              Confirm address before choosing an order type
                                                            </Button>
                                                        </Grid>
                                                        : "" }
                            </Grid>
                            { ([11].includes(Number(user.hospice_organization_id))) ?
                                                    showClose && (
                                                        <div>
                            <Grid item style={{padding:16}}>
                                <NewCreateOrder
                                                                                       user={user}
                                                                                       getPatientOrders={getPatientOrders}
                                                                                       isPace={isPace}
                                                                                       closeMobileModal={closeMobileModal}
                                                                                       mobileButton={true}
                                                                />
                            </Grid>
                            <CheckInventory patient_id={user.patient_id} width={true}>
                                <Grid item style={{padding:32, paddingTop:16}}>
                                    <RequestPickup
                                        openOrder={false}
                                        showPickup={true}
                                        disabled={(user.status === "Active" || ([11, 15].includes(Number(user.hospice_organization_id))))}
                                        name={name}
                                        address={address}
                                        patient_id={user.patient_id}
                                        getPatientOrders={getPatientOrders}
                                        closeMobileModal={closeMobileModal}
                                        mobileButton={true}
                                    />
                                    <RequestPickup
                                        openOrder={false}
                                        showPickup={false}
                                        name={name}
                                        autoTrigger={autoPickupTrigger}
                                        address={address}
                                        reason={autoPickupReason}
                                        patient_id={user.patient_id}
                                        getPatientOrders={getPatientOrders}
                                    />
                                </Grid>
                                <Grid item style={{paddingBottom:16}}>
                                    {((user.status === "Active" || ([15].includes(Number(user.hospice_organization_id)))) &&
                                    (Number(user.hospice_organization_id) !== 7) && (Number(user.hospice_organization_id) !== 11)) ?
                                        <RequestExchange
                                            openOrder={false}
                                            name={name}
                                            address={address}
                                            patientId={user.patient_id}
                                            hospice_id={user.hospice_organization_id}
                                            region_id={user.region_id}
                                            getPatientOrders={getPatientOrders}
                                            closeMobileModal={closeMobileModal}
                                            mobileButton={true}
                                        />
                                        :
                                        <Button
                                            variant="contained"
                                            disabled
                                            size="small"
                                            startIcon={<img
                                                src={ToolIcon}
                                                alt="logo"
                                                width='16'
                                                height='15'
                                            />}
                                            style={{
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                                width: 200,
                                                height: 60
                                            }}
                                        >
                                            NEW EXCHANGE
                                        </Button>
                                    }
                                </Grid>
                            </CheckInventory>
                            </div>
                                                    ) :
                            <div>
                            <Grid item style={{padding:16}}>
                                <NewCreateOrder
                                    user={user}
                                    getPatientOrders={getPatientOrders}
                                    isPace={isPace}
                                    closeMobileModal={closeMobileModal}
                                    mobileButton={true}
                                />
                            </Grid>
                            <CheckInventory patient_id={user.patient_id} width={true}>
                                                            <Grid item style={{padding:32, paddingTop:16}}>
                                                                <RequestPickup
                                                                    openOrder={false}
                                                                    showPickup={true}
                                                                    disabled={(user.status === "Active" || ([11, 15].includes(Number(user.hospice_organization_id))))}
                                                                    name={name}
                                                                    address={address}
                                                                    patient_id={user.patient_id}
                                                                    getPatientOrders={getPatientOrders}
                                                                    closeMobileModal={closeMobileModal}
                                                                    mobileButton={true}
                                                                />
                                                                <RequestPickup
                                                                    openOrder={false}
                                                                    showPickup={false}
                                                                    name={name}
                                                                    autoTrigger={autoPickupTrigger}
                                                                    address={address}
                                                                    reason={autoPickupReason}
                                                                    patient_id={user.patient_id}
                                                                    getPatientOrders={getPatientOrders}
                                                                />
                                                            </Grid>
                                                            <Grid item style={{paddingBottom:16}}>
                                                                {((user.status === "Active" || ([15].includes(Number(user.hospice_organization_id)))) &&
                                                                ((Number(user.hospice_organization_id) !== 7) || (Number(user.hospice_organization_id) !== 11))) ?
                                                                    <RequestExchange
                                                                        openOrder={false}
                                                                        name={name}
                                                                        address={address}
                                                                        patientId={user.patient_id}
                                                                        hospice_id={user.hospice_organization_id}
                                                                        region_id={user.region_id}
                                                                        getPatientOrders={getPatientOrders}
                                                                        closeMobileModal={closeMobileModal}
                                                                        mobileButton={true}
                                                                    />
                                                                    :
                                                                    <Button
                                                                        variant="contained"
                                                                        disabled
                                                                        size="small"
                                                                        startIcon={<img
                                                                            src={ToolIcon}
                                                                            alt="logo"
                                                                            width='16'
                                                                            height='15'
                                                                        />}
                                                                        style={{
                                                                            fontSize: 14,
                                                                            fontWeight: 'bold',
                                                                            width: 200,
                                                                            height: 60
                                                                        }}
                                                                    >
                                                                        NEW EXCHANGE
                                                                    </Button>
                                                                }
                                                            </Grid>
                                                        </CheckInventory>
                                                        </div>
                            }
                            <Grid item xs={12} style={{paddingTop: 16}}>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<Person
                                        alt="logo"
                                        width='16'
                                        height='15'
                                    />}
                                    onClick={() => history.push({
                                        pathname: `/patients/patientProfile/${user.patient_id}`,
                                        patient_id: user.patient_id
                                    })}
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                        width: 200,
                                        height: 60
                                    }}
                                >
                                    GO TO PROFILE
                                </Button>
                            </Grid>
                        </React.Fragment>
                    )}

                </Grid>

            </Dialog>
        </React.Fragment>
    )
}
